import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { UpdateAssigneeDto } from '../../../commonTypes/project.types';
import { ICallback } from '../../../commonTypes/hook.types';
import { useTranslation } from '../../useTranslation';

const useHttpPatchProjectAssignee = () => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (projectId: string, userSub: string, body: UpdateAssigneeDto, callback: ICallback) => {
        const { exec, clearCache, abort } = projectApi.updateAssignee({
            params: { projectId, userSub },
            body,
            onSuccess: _ => {
                toastHandler.push('success', t('projects.updateAssigneeTitle'), t('projects.updateAssigneeMessage_Success'));
                if (callback.onSuccess) callback.onSuccess();
                clearCache();
            },
            onError: _ => {
                toastHandler.push('error', t('projects.updateAssigneeTitle'), t('projects.updateAssigneeMessage_Failed'));
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPatchProjectAssignee;
